var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.125 2.625C3.39911 2.625 2 4.02411 2 5.75V19.5C2 21.2259 3.39911 22.625 5.125 22.625H18.875C20.6009 22.625 22 21.2259 22 19.5V5.75C22 4.02411 20.6009 2.625 18.875 2.625H5.125ZM17.228 9.91567C17.8028 9.27196 17.7469 8.28422 17.1032 7.70949C16.4595 7.13475 15.4717 7.19066 14.897 7.83437L10.4822 12.779L9.41554 11.5844C8.84081 10.9407 7.85307 10.8848 7.20937 11.4595C6.56566 12.0342 6.50975 13.022 7.08449 13.6657L9.31663 16.1657C9.61308 16.4977 10.0371 16.6875 10.4822 16.6875C10.9273 16.6875 11.3512 16.4977 11.6477 16.1657L17.228 9.91567Z",
    fill: "#3A836C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCheck);
export default __webpack_public_path__ + "static/media/new-check.5f97732ff2d41686b6b1ae8f2c7bd7c0.svg";
export { ForwardRef as ReactComponent };